export class SnsPreviewManagerListener {
    public static bindTextareaInput(textarea: HTMLTextAreaElement, onInput: () => void): void {
        textarea.addEventListener("input", onInput);
    }

    public static bindCardImageError(img: HTMLImageElement, onError: () => void): void {
        img.addEventListener("error", onError, { once: true });
    }
}
